{
  "welcome": {
    "title": "Мудрые беседы",
    "subtitle": "Выберите AI-компаньона для начала диалога.\nКаждый приносит уникальный взгляд на ваш путь.",
    "startConversation": "Начать беседу"
  },
  "companions": {
    "aiGuide": "AI-наставник",
    "whatCanYouAsk": "Что можно спросить?"
  },
  "sidebar": {
    "title": "Чаты",
    "aiCompanions": "AI-компаньоны",
    "masters": "Мастера",
    "friends": "Люди",
    "circles": "Круги",
    "recentChats": "НЕДАВНИЕ ЧАТЫ",
    "personal": "ЛИЧНОЕ",
    "notepad": "Ваш личный блокнот",
    "online": "Онлайн",
    "startConversation": "Начать диалог",
    "new": "Новый",
    "youPrefix": "Вы: ",
    "you": "Вы",
    "unreadA11y_one": "{{count}} непрочитанное сообщение",
    "unreadA11y_few": "{{count}} непрочитанных сообщения",
    "unreadA11y_many": "{{count}} непрочитанных сообщений",
    "unreadA11y_other": "{{count}} непрочитанного сообщения",
    "messagesTitle": "Сообщения",
    "messagesSubtitle": "Личные диалоги",
    "searchA11y": "Поиск по диалогам",
    "yesterday": "Вчера"
  },
  "chat": {
    "unnamedUser": "Пользователь",
    "messagePlaceholder": "Ваше сообщение…",
    "receiptRead": "Прочитано",
    "receiptSent": "Отправлено",
    "send": "Отправить",
    "sendHint": "Enter — отправить, Shift + Enter — новая строка",
    "placeholder": "Напишите заметку...",
    "masterPlaceholder": "Написать {{name}}...",
    "friendPlaceholder": "Написать {{name}}...",
    "master": "Мастер",
    "savedMessages": "Сохранённые",
    "notesStored": "Заметки хранятся локально на этом устройстве.",
    "messagesDelivered": "Сообщения доставляются напрямую мастеру.",
    "aiDisclaimer": "AI-ответы генерируются и могут быть неточными. В экстренных случаях обратитесь к специалисту.",
    "demoDisclaimer": "Демо-режим — ответы симулированы.",
    "jotDown": "Записывайте идеи для сессий, напоминания или что угодно на потом.",
    "startWith": "Начните беседу с {{name}}. Спросите о практиках, расписании или духовном руководстве.",
    "demoBadge": "ДЕМО · РЕАЛЬНЫЕ СООБЩЕНИЯ СКОРО",
    "typing": {
      "someone": "кто-то",
      "one": "{{name}} печатает…",
      "two": "{{name1}} и {{name2}} печатают…",
      "many": "{{count}} человек печатают…"
    },
    "date": {
      "today": "Сегодня",
      "yesterday": "Вчера",
      "unreadDivider": "Новые сообщения"
    },
    "empty": {
      "channel": {
        "title": "Тут пока тихо",
        "description": "Напиши первое сообщение — пусть круг оживёт"
      },
      "message": {
        "title": "Сообщений пока нет",
        "description": "Начни разговор первым"
      },
      "thread": {
        "title": "Обсуждение пока пустое",
        "description": "Ответь, чтобы развить мысль"
      },
      "pinned": {
        "title": "Пока ничего не закреплено",
        "description": "Закрепляй ценные сообщения — потом проще найти"
      }
    },
    "pinned": {
      "label": "Закреплено",
      "fullTitle": "Закреплённое сообщение",
      "readMore": "Читать далее",
      "unpin": "Открепить",
      "limitToast": "Уже закреплено сообщение. Открепи его, чтобы закрепить новое."
    },
    "bounce": {
      "title": "Сообщение задержано",
      "description": "Похоже, в твоём сообщении есть фраза, которую сообщество встречает с осторожностью. Перефразируй — и попробуй снова.",
      "editAndSend": "Изменить и отправить",
      "sendAnyway": "Отправить всё равно",
      "delete": "Удалить",
      "editingTitle": "Отредактируй и отправь снова",
      "editPlaceholder": "Перефразируй сообщение…",
      "send": "Отправить",
      "sending": "Отправляю…",
      "cancel": "Отмена"
    },
    "voiceBlocked": {
      "title": "Голосовое не отправлено",
      "description": "Похоже, в голосовом есть слова, которые сообщество встречает с осторожностью. Запиши новое сообщение — и попробуй снова.",
      "ok": "Понятно"
    },
    "aboutEvent": "О Live-сессии",
    "archiveNotice": "Live-сессия завершена. Здесь остались сообщения из чата.",
    "byMaster": "Ведёт {{name}}",
    "customAmount": "Другая сумма",
    "defaultDescription": "Живая встреча с {{name}} — приходите побыть вместе.",
    "disconnected": "Связь потеряна",
    "firstMessage": "Здесь пока тихо",
    "host": "Ведущий",
    "liveSession": "Live-сессия",
    "offering": "Поддержать",
    "reconnecting": "Восстанавливаем связь…",
    "sayHello": "Поздоровайтесь с сообществом",
    "thankYou": "Спасибо за поддержку — {{amount}}",
    "time": {
      "now": "только что",
      "minutesAgo": "{{count}} мин назад"
    },
    "fragment": {
      "ask": "Спросить об этом",
      "askAboutPhrase": "Спросить о фразе",
      "pickTitle": "Выделите фразу",
      "pickHint": "Выделите в сообщении то, о чём хотите спросить.",
      "cancel": "Отмена",
      "originalDeleted": "Исходное сообщение удалено"
    }
  },
  "categories": {
    "ai": "AI",
    "masters": "Мастера",
    "friends": "Друзья",
    "circles": "Круги"
  },
  "wisdomCouncil": {
    "title": "Совет Мудрости",
    "subtitle": "Спросите мудрецов",
    "description": "Задавайте вопросы совету. Используйте @упоминания для обращения к конкретным мудрецам.",
    "members": "Участники совета",
    "starredMessages": "Избранные сообщения",
    "starredEmpty": "Отмечайте сообщения звёздочкой, чтобы сохранить мудрость",
    "starMessage": "⭐ В избранное",
    "unstarMessage": "★ Убрать",
    "tabs": {
      "answer": "Ответ",
      "links": "Ссылки",
      "media": "Медиа"
    },
    "devDayMinutes": "1 день ="
  },
  "sidebarEmpty": {
    "noResults": "Ничего не найдено",
    "noContacts": "Контактов пока нет",
    "createTestCircle": "Создать тестовый круг",
    "devOnlyHint": "dev-only • чтобы протестировать события"
  },
  "authGate": {
    "title": "Войдите, чтобы открыть чаты",
    "description": "Войдите в аккаунт, чтобы общаться с AI-компаньонами, мастерами, друзьями и в кругах.",
    "logIn": "Войти",
    "noAccount": "Нет аккаунта? Зарегистрироваться"
  },
  "moderation": {
    "unmute": "Снять mute",
    "mute": "Замьютить",
    "kick": "Выкинуть из круга",
    "ban": "Забанить навсегда",
    "kickConfirmTitle": "Выкинуть из круга",
    "kickConfirmBody": "Точно выкинуть {{name}}? Они потеряют доступ к чату и событиям круга.",
    "kickWorking": "Убираем…",
    "kickConfirm": "Выкинуть",
    "banConfirmTitle": "Забанить навсегда",
    "banConfirmBody": "{{name}} больше никогда не сможет вернуться в круг. Точно?",
    "banWorking": "Баним…",
    "banConfirm": "Забанить",
    "mutePickerTitle": "Замьютить {{name}}",
    "mutePickerBody": "Не сможет писать, но останется в круге и видит контент",
    "muteDurations": {
      "h1": "1 час",
      "h24": "24 часа",
      "d7": "7 дней",
      "forever": "Навсегда"
    },
    "cancel": "Отмена"
  },
  "native": {
    "subtitle": "Ближе к тем, кто рядом по духу",
    "searchPlaceholder": "Поиск по сообщениям",
    "tabs": {
      "all": "Все",
      "ai": "AI",
      "people": "Люди"
    },
    "empty": "Диалогов пока нет",
    "loadFailed": "Не удалось загрузить чаты",
    "aiSection": "AI-собеседники",
    "peopleSection": "Люди",
    "aiFriend": "AI-друг",
    "peer": "Собеседник",
    "draft": "Черновик: ",
    "thread": {
      "sendFailBody": "Нет связи с чатом. Текст остался в поле — попробуйте ещё раз.",
      "sendFailBodyShort": "Нет связи с чатом. Попробуйте ещё раз.",
      "voiceFailBody": "Нет связи с чатом. Запись сохранена — можно отправить ещё раз.",
      "voiceFailed": "Голосовое не отправилось",
      "failedTitle": "Не удалось",
      "unpinFailed": "Не получилось открепить сообщение.",
      "pinUnavailable": "Закрепление недоступно в этом чате (нет прав).",
      "fileFailed": "Файл не отправился",
      "editFailed": "Правка не сохранилась",
      "messageFailed": "Сообщение не отправилось",
      "reactionFailed": "Реакция не сохранилась",
      "deleteFailed": "Сообщение не удалилось",
      "online": "В сети",
      "personalDialog": "Личный диалог",
      "inviteToRoom": "Позвать в Live-сессию",
      "attach": "Прикрепить файл",
      "emoji": "Фирменные эмодзи",
      "voice": "Голосовое сообщение",
      "scrollDown": "К последним сообщениям",
      "openFailed": "Не удалось открыть чат",
      "openFailedHint": "Нет связи с сервером сообщений. Проверьте интернет и попробуйте ещё раз.",
      "encrypted": "Сообщения защищены сквозным шифрованием.",
      "photo": "Фото",
      "captionHint": "Добавьте подпись (необязательно)",
      "editing": "Редактирование",
      "replyTo": "Ответ {{name}}",
      "attachment": "Вложение",
      "micHint": "Удерживайте, чтобы записать голосовое",
      "youBlocked": "Вы заблокировали этого пользователя",
      "unblock": "Разблокировать",
      "messageLabel": "Сообщение",
      "composerPlaceholder": "Сообщение...",
      "roomInvite": "Приглашаю в Live-сессию: {{url}}",
      "inviteFailed": "Приглашение не отправилось. Попробуйте ещё раз из чата.",
      "clearAllFailed": "Не получилось очистить переписку у всех. Попробуйте ещё раз.",
      "blockRejected": "Сервер отклонил блокировку",
      "chatKept": "Чат не удалён.",
      "releaseToCancel": "Отпустите для отмены",
      "swipeToCancel": "‹ смахните для отмены",
      "typing": "печатает",
      "removeReaction": "Убрать реакцию {{emoji}}",
      "addReaction": "Поставить реакцию {{emoji}}",
      "voiceRetry": "Повторить",
      "voiceDiscard": "Удалить"
    },
    "menu": {
      "profile": "Профиль",
      "search": "Поиск",
      "mute": "Без звука",
      "unmute": "Включить звук",
      "clear": "Очистить чат",
      "block": "Заблокировать",
      "deleteChat": "Удалить переписку",
      "deleteAndBlock": "Удалить и заблокировать",
      "reply": "Ответить",
      "pin": "Закрепить",
      "deleteForMe": "Удалить у себя"
    },
    "block": {
      "title": "Заблокировать {{name}}?",
      "body": "Заблокированный больше не сможет вам писать.",
      "andDelete": "Заблокировать и удалить чат"
    },
    "clear": {
      "title": "Очистить чат?",
      "body": "Выберите, как удалить переписку.",
      "selfOnly": "Удалить только у себя",
      "everyone": "Удалить у всех"
    },
    "confirmRoom": {
      "title": "Вы действительно хотите перейти в Live-сессию?",
      "yes": "Да"
    }
  },
  "agapellaSubscriptionOffer": {
    "button": "Оформить подписку Agapēlla"
  },
  "tour": {
    "replayCta": "Пройти знакомство с платформой",
    "replayAgain": "Пройти знакомство ещё раз"
  },
  "preview": {
    "attachment": {
      "voiceRecording": "Голосовое сообщение",
      "image": "Фото",
      "video": "Видео",
      "audio": "Аудио",
      "giphy": "GIF",
      "file": "Вложение"
    }
  },
  "thread": {
    "opening": "Открываем беседу…"
  },
  "emptyDialog": {
    "title": "Ближе друг к другу",
    "subtitle": "Выберите диалог слева, чтобы продолжить общение",
    "circlesTitle": "Круги",
    "circlesSubtitle": "Выберите круг, чтобы открыть обсуждение."
  },
  "aiNotice": {
    "caption": "Ответы формирует ИИ",
    "link": "Уведомление об ИИ"
  },
  "aiConsentDeclined": {
    "title": "Хорошо, без ИИ-помощницы",
    "body": "Пока согласия нет, чат с Агапеллой закрыт и ИИ-сервису ничего не передаётся. Остальная платформа работает как обычно. Передумаешь — условия можно прочитать ещё раз.",
    "readAgain": "Прочитать условия ещё раз"
  }
}
